<template>
  <div class="ammeterChangeRecord-container">
    <el-row class="ammeterChangeRecord-top">
      <el-form
        inline
        size="medium"
        :model="queryForm"
        ref="queryForm"
        @submit.native.prevent
      >
        <el-form-item class="r-20" prop="vin">
          <el-input
            placeholder="车架号"
            v-model.trim="queryForm.vin"
            @keyup.enter.native="query"
          ></el-input>
        </el-form-item>
        <el-form-item class="r-20" prop="oldAmmeterNumber">
          <el-input
            placeholder="原电表编号"
            v-model.trim="queryForm.oldAmmeterNumber"
            @keyup.enter.native="query"
          ></el-input>
        </el-form-item>
        <el-form-item class="r-20" prop="newDeviceNumber">
          <el-input
            placeholder="新设备编号"
            v-model.trim="queryForm.newDeviceNumber"
            @keyup.enter.native="query"
          ></el-input>
        </el-form-item>
        <el-form-item class="r-20" prop="creator">
          <el-input
            placeholder="创建人员"
            v-model.trim="queryForm.creator"
            @keyup.enter.native="query"
          ></el-input>
        </el-form-item>
        <el-button type="primary" @click="query">查询</el-button>
        <el-button @click="reset">取消</el-button>
      </el-form>
      <el-button type="primary" @click="add">新增</el-button>
      <!-- <el-button type="primary" @click="editor">修改</el-button> -->
      <!-- <el-button type="danger" @click="delData">删除</el-button> -->
    </el-row>
    <el-row class="ammeterChangeRecord-top">
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        size="mini"
        stripe
        height="560px"
        @selection-change="handleSelectionChange"
      >
        <el-table-column width="24"></el-table-column>
        <el-table-column type="index" label="序号"></el-table-column>
        <el-table-column
          label="车架号"
          min-width="160"
          prop="vin"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="原电表型号"
          prop="historicalModel"
          min-width="120"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="原电表编号"
          prop="historyNumber"
          min-width="120"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="原电表数值（KW·H）"
          min-width="150"
          prop="historicalEnergy"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="新电表型号"
          prop="newModel"
          min-width="120"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="新电表编号"
          prop="newNumber"
          min-width="120"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="更换时间"
          min-width="160"
          prop="replacementTime"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="新电表数值（KW·H）"
          min-width="150"
          prop="newEnergy"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="创建人员"
          prop="founder"
          min-width="90 "
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="创建时间"
          min-width="140"
          prop="addTime"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="操作" fixed="right">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              style="margin-left: 10px"
              @click="editor(row)"
              >修改</el-button
            >
            <el-button
              type="text"
              style="margin-left: 10px"
              @click="delData(row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      layout="total,prev,pager,next,jumper"
      :total="total"
    ></el-pagination>

    <!-- 新增或修改弹框 -->
    <el-dialog
      :title="`${dialogTitle}电表更换记录`"
      :visible.sync="dialogVisible"
      class="vehicle-dialog"
    >
      <el-form
        :rules="ammeterReplaceRules"
        ref="ammeterReplaceForm"
        :model="ammeterReplaceForm"
        size="mini"
        inline
      >
        <el-form-item label="车架号" prop="vin">
          <el-input
            :disabled="disabledId"
            v-model.trim="ammeterReplaceForm.vin"
            placeholder="请输入车架号"
          ></el-input>
        </el-form-item>
        <el-form-item label="原电表型号" prop="historicalModel">
          <el-input
            :disabled="disabledId"
            v-model.trim="ammeterReplaceForm.historicalModel"
            placeholder="请输入原电表型号"
          ></el-input>
        </el-form-item>
        <el-form-item label="原电表编号" prop="historyNumber">
          <el-input
            :disabled="disabledId"
            v-model.trim="ammeterReplaceForm.historyNumber"
            placeholder="请输入原电表编号"
          ></el-input>
        </el-form-item>
        <el-form-item label="原电表数值（KW·H）" prop="historicalEnergy">
          <el-input
            :disabled="disabledId"
            v-model.trim="ammeterReplaceForm.historicalEnergy"
            placeholder="请输入原电表数值"
          ></el-input>
        </el-form-item>
        <el-form-item label="新电表型号" prop="newModel">
          <el-input
            :disabled="disabledId"
            v-model.trim="ammeterReplaceForm.newModel"
            placeholder="请输入新电表型号"
          ></el-input>
        </el-form-item>
        <el-form-item label="新电表编号" prop="newNumber">
          <el-input
            :disabled="disabledId"
            v-model.trim="ammeterReplaceForm.newNumber"
            placeholder="请输入新电表编号"
          ></el-input>
        </el-form-item>
        <el-form-item label="新电表数值（KW·H）" prop="newEnergy">
          <el-input
            :disabled="disabledId"
            v-model.trim="ammeterReplaceForm.newEnergy"
            placeholder="请输入新电表数值"
          ></el-input>
        </el-form-item>
        <el-form-item label="更换时间" prop="replacementTime">
          <el-date-picker
            :disabled="disabledId"
            :editable="false"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model.trim="ammeterReplaceForm.replacementTime"
            type="datetime"
            placeholder="请输入更换时间"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveOrUpdate">确 定</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "AmmeterChangeRecord",
  data() {
    return {
      queryForm: {
        vin: "",
        oldAmmeterNumber: "",
        newDeviceNumber: "",
        creator: "",
      },
      tableVal: [],
      tableData: [],
      currentPage: 1,
      limit: 10,
      total: 300,
      dialogTitle: "",
      dialogVisible: false,
      ammeterReplaceForm: {},
      disabledId: false,
      ammeterReplaceRules: {
        vin: [
          {
            required: true,
            pattern: this.$formRules.vin,
            message: this.$formRules.vinMsg,
            trigger: "blur",
          },
        ],
        replacementTime: [
          {
            required: true,
            trigger: "change",
            message: "请输入更换时间",
          },
        ],
        historyNumber: [
          {
            required: true,
            trigger: "change",
            message: "请输入原电表编号",
          },
        ],
        historicalEnergy: [
          {
            required: true,
            pattern: this.$formRules.threeDecimal,
            message: this.$formRules.threeDecimalMsg,
            trigger: "blur",
          },
        ],
        newEnergy: [
          {
            required: true,
            pattern: this.$formRules.threeDecimal,
            message: this.$formRules.threeDecimalMsg,
            trigger: "blur",
          },
        ],
        newNumber: [
          {
            required: true,
            trigger: "change",
            message: "请输入新电表编号",
          },
        ],
      },
      editTag: false,
    };
  },
  mounted() {
    this.getTableList();
  },
  methods: {
    query() {
      console.log(this.queryForm);
      this.getTableList();
    },
    reset() {
      console.log("reset");
      this.$resetForm(this, "queryForm");
      this.getTableList();
    },
    add() {
      this.ammeterReplaceForm = {};
      //清空表单数据
      this.$resetForm(this, "ammeterReplaceForm");
      // 状态改为新增
      this.editTag = false;
      // // 禁用解除
      // this.disabledId = false;
      //设置弹框标题
      this.dialogTitle = "新增";
      //显示弹框
      this.dialogVisible = true;
    },
    editor(row) {
      //清空表单数据
      this.$resetForm(this, "ammeterReplaceForm");
      // 状态改为修改
      this.editTag = true;
      // 赋值
      this.ammeterReplaceForm = { ...row };
      // // 禁用
      // this.disabledId = true;
      //设置弹框标题
      this.dialogTitle = "修改";
      //显示弹框
      this.dialogVisible = true;
    },

    delData(row) {
      let id = row.id;
      this.$confirm("确定删除吗？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let { data: res } = await this.$axios.get(
          `/api/electricity/meterReplace/delete?id=${id}`
        );
        if (res.code == 1) {
          this.$message.success("操作成功");
          let totalPage = Math.ceil((this.total - 1) / 10);
          let currentPage =
            this.currentPage > totalPage ? totalPage : this.currentPage;
          this.currentPage = currentPage < 1 ? 1 : currentPage;
          this.getTableList();
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    saveOrUpdate() {
      this.$refs.ammeterReplaceForm.validate(async (valid) => {
        if (valid) {
          if (this.editTag) {
            // 修改状态
            let { data: res } = await this.$axios.post(
              "/api/electricity/meterReplace/update",
              this.ammeterReplaceForm
            );
            if (res.code == 1) {
              this.$message.success(res.msg);
              //关闭弹框
              this.dialogVisible = false;
              //刷新表格数据
              this.getTableList();
            } else {
              this.$message.warning(res.msg);
            }
          } else {
            // 新增
            console.log(this.ammeterReplaceForm);
            let { data: res } = await this.$axios.post(
              "/api/electricity/meterReplace/save",
              this.ammeterReplaceForm
            );
            if (res.code == 1) {
              this.dialogVisible = false;
              this.$resetForm(this, "ammeterReplaceForm");
              this.getTableList();
              this.$message.success("操作成功");
            } else {
              this.$message.warning(res.msg);
            }
          }
        }
      });
    },
    //选择数据变化监控
    handleSelectionChange(val) {
      this.tableVal = val;
    },
    async getTableList() {
      let obj = {};
      obj.vin = this.queryForm.vin;
      obj.historyNumber = this.queryForm.oldAmmeterNumber;
      obj.newNumber = this.queryForm.newDeviceNumber;
      obj.founder = this.queryForm.creator;
      obj.limit = this.limit;
      obj.page = this.currentPage;
      let { data: res } = await this.$axios.get(
        "/api/electricity/meterReplace/list",
        {
          params: obj,
        }
      );
      if (res.code == 1) {
        this.tableData = res.data.list;
        this.total = res.data.totalCount;
      } else {
        this.$message.warning(res.msg);
      }
    },
    //pagesize改变时触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    //页数改变时触发
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getTableList();
    },
  },
};
</script>

<style lang="scss" scoped>
.ammeterChangeRecord-container {
  height: calc(100% - 40px);
  padding: 0 20px;
  margin: 20px;
  background: #fff;
  .ammeterChangeRecord-top {
    padding-top: 20px;
    /deep/ .el-input,
    .el-input__inner {
      width: 260px;
    }
    /deep/ .el-button + .el-button {
      margin-left: 20px;
    }
    /deep/ .el-form .el-button {
      margin-right: 0;
    }
  }
  // 弹窗
  .vehicle-dialog {
    /deep/ .el-dialog {
      width: 600px;
    }
    /deep/ .el-form-item__label {
      width: 170px;
      height: 32px;
      margin-left: 20px;
      text-align: left;
      color: #343434;
      font-size: 14px;
    }
    /deep/ .el-form-item__content {
      width: 360px;
      height: auto;
    }
    /deep/ .el-form-item__content {
      width: 360px;
    }
    /deep/ .el-date-editor.el-input {
      width: 360px;
    }
    /deep/ .el-form-item__content {
      line-height: 32px;
    }
  }

  /deep/ .el-date-editor {
    input {
      padding: 0 15px;
    }
    .el-input__prefix {
      left: auto;
      right: 10px;
      color: #333;
      .el-icon-time:before {
        content: "\e78e";
      }
    }
    .el-input__suffix {
      .el-input__icon.el-icon-circle-close {
        display: none;
      }
    }
  }
}
</style>
